"use strict";

var _createClass = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _classCallCheck = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FDSCrypto = _interopRequireDefault(require("./FDS-Crypto.js"));

var _web = _interopRequireDefault(require("web3"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Copyright 2019 The FairDataSociety Authors
// This file is part of the FairDataSociety library.
//
// The FairDataSociety library is free software: you can redistribute it and/or modify
// it under the terms of the GNU Lesser General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// The FairDataSociety library is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
// GNU Lesser General Public License for more details.
//
// You should have received a copy of the GNU Lesser General Public License
// along with the FairDataSociety library. If not, see <http://www.gnu.org/licenses/>.
// thin wrapper around ethereumjs-wallet


var web3 = new _web.default();

var WalletClass = function WalletClass(attrs) {
  _classCallCheck(this, WalletClass);

  this.address = attrs.address || null;
  this.publicKey = attrs.publicKey || null;
  this.privateKey = attrs.privateKey || null;
};

var Wallet =
/*#__PURE__*/
function () {
  function Wallet() {
    _classCallCheck(this, Wallet);
  }

  _createClass(Wallet, [{
    key: "generate",

    /**
     * Generate new wallet 
     * @param {string} password to use when generating wallet
     * @returns {Wallet} new wallet
     */
    value: function generate(password) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          var account = web3.eth.accounts.create();
          var wallet = new WalletClass({
            address: account.address.toLowerCase(),
            publicKey: _FDSCrypto.default.privateToPublicKey(account.privateKey),
            privateKey: account.privateKey
          });
          _this.wallet = wallet;
          _this.walletV3 = web3.eth.accounts.encrypt(account.privateKey, password);
          resolve(_this);
        });
      });
    }
    /**
     * Create wallet from json string 
     * @param {string} walletJSON string
     * @param {string} password to use
     * @returns {Wallet} wallet
     */

  }, {
    key: "fromJSON",
    value: function fromJSON(walletJSON, password) {
      return new Promise(function (resolve, reject) {
        try {
          var account = web3.eth.accounts.decrypt(walletJSON, password);
          var wallet = new WalletClass({
            address: account.address.toLowerCase(),
            publicKey: _FDSCrypto.default.privateToPublicKey(account.privateKey),
            privateKey: account.privateKey
          });
          resolve(wallet);
        } catch (err) {
          if (err.message === "Key derivation failed - possibly wrong passphrase") {
            reject(false);
          } else {
            throw new Error(err);
          }
        }
      });
    }
    /**
     * Restores wallet from private key
     * @param {string} privateKey private key string, no 0x
     * @param {string} password to use
     * @returns {Wallet} wallet
     */

  }, {
    key: "encrypt",
    value: function encrypt(privateKey, password) {
      return new Promise(function (resolve, reject) {
        try {
          var walletV3 = web3.eth.accounts.encrypt(privateKey, password);
          var walletJSON = JSON.stringify(walletV3);
          resolve(walletJSON);
        } catch (err) {
          throw new Error(err);
        }
      });
    }
  }]);

  return Wallet;
}();

var _default = Wallet;
exports.default = _default;
module.exports = exports.default;